import type { Member } from 'app/scripts/models/member';
import { isGuestOrganization } from 'app/scripts/network/rpc/isGuestOrganization';
import type { RpcModel } from 'app/scripts/network/rpc/rpc.types';

export const verificationUrls = (
  currentSubscriptions: Record<string, RpcModel>,
  me?: Member,
) => {
  const subscriptions = Object.values(currentSubscriptions);
  const idBoards = me && me.get('idBoards');
  const idOrganizations = me && me.get('idOrganizations');
  return subscriptions
    .map(({ modelType, idModel }) => {
      const url = (() => {
        switch (modelType) {
          case 'Board':
            if (idBoards && Array.from(idBoards).includes(idModel)) {
              // If it's in our idBoards we're allowed to see it
              return null;
            } else {
              return `/boards/${idModel}/name`;
            }
          case 'Member':
            if (idModel === me?.id) {
              // Don't bother checking if we can read our member channel
              return null;
            } else {
              return `/members/${idModel}/fullName`;
            }
          case 'Organization':
            if (
              (idOrganizations &&
                Array.from(idOrganizations).includes(idModel)) ||
              isGuestOrganization(modelType, idModel, me)
            ) {
              // If it's in our idOrganizations or we're a guest of
              // the organization (on a board owned by the org) we're
              // allowed to see it
              return null;
            } else {
              return `/organizations/${idModel}/displayName`;
            }
          default:
            return null;
        }
      })();

      if (url) {
        return { id: idModel, url };
      }
    })
    .filter((entry) => !!entry);
};
